class ProductSlider extends HTMLElement {
    connectedCallback() {
        this.slider = this.querySelector('[data-slider]');
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');

        if (this.prev) {
            this.prev.addEventListener('click', () => this.slide(-1));
        }

        if (this.next) {
            this.next.addEventListener('click', () => this.slide(1));
        }

        // Touch support mapping for quick swipe overrides, though native scroll-snap helps usually
        let startX;
        if (this.slider) {
            this.slider.addEventListener('touchstart', (e) => {
                startX = e.touches[0].clientX;
            }, { passive: true });

            this.slider.addEventListener('touchend', (e) => {
                const diff = startX - e.changedTouches[0].clientX;
                if (Math.abs(diff) > 50) {
                    this.slide(diff > 0 ? 1 : -1);
                }
            }, { passive: true });
        }
    }

    slide(direction) {
        if (!this.slider) return;
        const card = this.slider.querySelector('li');
        if (!card) return;

        // Calculate scroll amount based on card width + gap (16px)
        const cardWidth = card.offsetWidth + 16;
        this.slider.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });

        // Update ARIA live region (optional, to inform screen readers)
        const liveRegion = this.querySelector('[aria-live="polite"]');
        if (liveRegion) {
            // Force screen reader to announce scroll update
            liveRegion.setAttribute('aria-busy', 'true');
            setTimeout(() => {
                liveRegion.removeAttribute('aria-busy');
            }, 500);
        }
    }
}

if (!customElements.get('product-slider')) {
    customElements.define('product-slider', ProductSlider);
}
